import * as React from "react";

import "./return-address-fields.scss";

import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {fragments}         from "@Common/react/fragments";
import {Invoke}            from "@Common/react/invoke";
import {keyed}             from "@Common/react/keyed";
import {scopedState}       from "@Common/react/scoped-state";
import {scnv}              from "@Common/react/state-change-nested-value";
import {UseState}          from "@Common/react/use-state";
import {setCurrentToSaved} from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {cnv}               from "@Common/utils/arr-path";
import {createArray}       from "@Common/utils/collections";
import {chain}             from "@Common/utils/fs";
import {
    equalDeep, filterKeys, isEmpty, mapKeys
}                          from "@Common/utils/objects";

import {FieldLine} from "../common/field-line";

export const ReturnAddressFields = ({initEnrollment, program, next}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    ["address", ({}, next) => UseState({
        getInitValue: () => chain(
            initEnrollment?.profile?.returnAddress,
            (_) => ({
                current: _,
                saved  : _,
            })
        ),
        next,
    })],
    ({session, address}, next) => fragments(
        next(),

        // Pre-populate fields with office return address by default
        // TODO, is branchDisplay fields correct?
        isEmpty(address.value.current) && session.data?.branch && Invoke({
            action: async () => {
                // console.log(session.data);
                scnv(address, ["current"], () => chain(
                    session.data.branch,
                    (_) => filterKeys(_, (k:string) => /branchDisplay[1-6]/.test(k)),
                    (_) => mapKeys(_, (k) => k.replace("branchDisplay", "address")),
                ));
            },
        })
    ),
    ["editable", (_, next) => next(
        // Customizable Return Address Fields
        program.programPreferences.customizableReturnAddress
    )],
    ({address, editable}) => next({
        enrollmentEditor: {
            $name: "Return address",
            prepareSave: (enrollment) => ({
                newValue: cnv(enrollment, ["profile", "returnAddress"], (_) => address.value.current),
                onSaved: () => setCurrentToSaved(address),
            }),
            changed: !equalDeep(address.value.saved, address.value.current),
            // valid: address.value.current,
            valid: true,
        },
        render: ({}) => cs(
            ({}) => (
                <div className="return-address-fields-2w2">
                    <div {...{
                        className: "header",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Return Address",
                    }}>
                        Return Address
                    </div>
                    <div className="lines">
                        {lines.map(({label, attr, maxLength}) => cs(
                            keyed(label),
                            () => FieldLine({
                                state: scopedState(address, ["current", attr]),
                                editable,
                                grey: !editable,
                                label,
                                maxLength,
                            }),
                        ))}
                    </div>
                </div>
            )
        ),
    }),
);

const lines = createArray(6).map((i) => ({
    label: "Address " + (i + 1),
    attr: "address" + (i + 1),
    "maxLength": 250,
}));


